<template>
  <div>
    <b-table small striped hover
    @row-clicked="rowGroupClickHandler"
    :items="groups"
    :fields="groupsFields">
    </b-table>
    <b-row>
      <b-col>
        <b-button  variant="success" style="float: right; width: 100px" @click.stop="addGroups">Ok</b-button>
      </b-col>
      <b-col sm="3">
        <b-button variant="secondary" style="float: right; width: 100px" @click.stop="hideFormGroups">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      selectGroup: null,
      groups: [],
      groupsFields: [
        {key: 'group_id', label: 'ID', sortable: true},
        {key: 'group_name', label: this.$i18n.t('Name'), sortable: true}
      ]
    }
  },
  methods: {
    async load () {
      this.groups = await axiosInstance.get(this.$store.getters.API_USERS_GROUPS).then(response => { return response.data })
    },
    hideFormGroups () {
      this.$emit('hideFormGroups')
    },
    rowGroupClickHandler (row) {
      if (this.selectGroup) {
        this.selectGroup._rowVariant = ''
      }
      this.selectGroup = row
      this.group_id = row.group_id
      this.$set(this.selectGroup, '_rowVariant', 'info')
    },
    addGroups () {
      if (!this.selectGroup) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select Group'), 'Error')
        return
      }
      let isFound = this.currentRow.groups.find(item => {
        if (item === this.selectGroup.group_id) {
          return true
        }
      })

      if (isFound === undefined) {
        this.currentRow.groups.push(this.selectGroup.group_id)
        this.hideFormGroups()
        this.$emit('refresh')
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Such a Group already exists'), 'Error')
      }
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/groups/formAddGroup.vue